import Vue from 'vue'
import VueRouter from 'vue-router'

 
Vue.use(VueRouter)
const routes=[
    {
        path: "/qyhy",
        name: "xctUI",
        component: () => import("@/views/xctUI/"),
    },
]

const router= new VueRouter({
    routes,
    mode: "history",
})
export default router